import React from "react";
import { Heading } from "@chakra-ui/react";
import Balancer from "@hightouchio/react-wrap-balancer";
export function UpsellHeading({ children, size = "md", ...props }) {
    return (React.createElement(Heading, { variant: "upsell", size: `upsell-${size}`, ...props },
        React.createElement(Balancer, { ratio: 0.65 }, children)));
}
